<template>
  <div class="promoter-rule-page">
    <real-name-auth-gate @authenticated="init">
      <template slot-scope="{ authenticated }">
        <div v-if="authenticated">
          <el-card class="rule-card" shadow="never">
      <div class="station-row">
        <span class="station-label">选择油站：</span>
        <el-select
          v-model="gasId"
          class="station-select"
          size="small"
          filterable
          placeholder="请选择油站"
          @change="handleGasChange">
          <el-option v-for="item in gasList" :key="item.gasId" :label="item.gasName" :value="item.gasId"></el-option>
        </el-select>
      </div>

      <div class="setup-steps">
        <div
          v-for="(step, index) in steps"
          :key="step.key"
          class="setup-step"
          :class="{ completed: step.completed, active: index === activeStepIndex }"
          @click="handleStepClick(index)">
          <div class="step-main">
            <div class="step-circle">{{ index + 1 }}</div>
            <div v-if="index < steps.length - 1" class="step-line"></div>
          </div>
          <div class="step-title">
            {{ step.title }}
            <el-tooltip v-if="step.tip" effect="dark" :content="step.tip" placement="top">
              <i class="el-icon-question step-tip-icon"></i>
            </el-tooltip>
          </div>
          <div class="step-status">{{ step.statusText }}</div>
        </div>
      </div>

      <el-tabs v-model="activeTab" class="rule-tabs" :before-leave="beforeTabLeave">
        <el-tab-pane label="老板账户" name="boss">
          <div v-loading="bossLoading" class="boss-panel">
            <div class="panel-title">创建老板账户</div>
            <div class="panel-desc">老板账户不管谁推广都会获得推广费的收益</div>
            <div v-if="hasBossAccount" class="boss-preview">
              <div class="preview-row">
                <span class="preview-label">推广油站：</span>
                <span class="preview-value">{{ currentGasName }}</span>
              </div>
              <div class="preview-row">
                <span class="preview-label">人员名称：</span>
                <span class="preview-value">{{ overview.bossAccount.bossName }}</span>
              </div>
              <div class="preview-row">
                <span class="preview-label">手机号：</span>
                <span class="preview-value">{{ overview.bossAccount.bossMobile }}</span>
              </div>
              <div class="preview-row">
                <span class="preview-label">创建时间：</span>
                <span class="preview-value">{{ overview.bossAccount.createTime || '--' }}</span>
              </div>
            </div>
            <el-form v-else ref="bossForm" :model="bossForm" :rules="bossRules" label-width="90px" class="boss-form">
              <el-form-item label="推广油站">
                <span class="form-text">{{ currentGasName }}</span>
              </el-form-item>
              <el-form-item label="人员名称" prop="bossName">
                <el-input v-model.trim="bossForm.bossName" maxlength="10" show-word-limit placeholder="请输入"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="bossMobile">
                <el-input v-model.trim="bossForm.bossMobile" maxlength="11" placeholder="请输入"></el-input>
              </el-form-item>
              <div class="form-tip">请填写老板真实手机号，后续影响到推广费用收益进入的账户</div>
            </el-form>
          </div>
          <div v-if="!hasBossAccount" class="bottom-action">
            <el-button type="primary" :loading="bossSubmitting" @click="createBoss">创建</el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane label="推广人管理" name="promoter">
          <div class="tab-body">
            <el-form :inline="true" :model="promoterSearchForm" size="small" class="promoter-search">
              <el-form-item label="推广人名称：">
                <el-input v-model.trim="promoterSearchForm.promoterName" placeholder="请输入" clearable></el-input>
              </el-form-item>
              <el-form-item label="创建时间：">
                <el-date-picker
                  v-model="promoterCreateTime"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                  @change="handlePromoterTimeChange">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="search-actions">
                <el-button size="small" @click="resetPromoterSearch">重置</el-button>
                <el-button type="primary" size="small" @click="queryPromoterList">搜索</el-button>
              </el-form-item>
            </el-form>

            <div class="promoter-toolbar">
              <div class="section-title">推广人列表</div>
              <div class="toolbar-actions">
                <!-- <el-button type="primary" size="small" @click="personHandover">人员交接</el-button> -->
                <el-button type="primary" size="small" @click="downloadStationPromotionCode">下载油站推广码</el-button>
                <el-button type="primary" size="small" @click="openAddPromoterDialog">添加推广人</el-button>
              </div>
            </div>
            <el-table v-loading="promoterListLoading" :data="promoterTableData" border stripe size="small" empty-text="暂无推广人比例" style="width: 100%">
              <el-table-column label="推广人名称" prop="promoterName" min-width="120" align="center"></el-table-column>
              <el-table-column label="手机号" prop="promoterMobile" min-width="140" align="center">
                <template slot-scope="{row}">{{ maskPhone(row.promoterMobile) }}</template>
              </el-table-column>
              <el-table-column label="所属油站" prop="gasName" min-width="130" align="center">
                <template slot-scope>{{ currentGasName }}</template>
              </el-table-column>
              <el-table-column label="推广人上级" prop="parentPromoterName" min-width="120" align="center">
                <template slot-scope="{row}">{{ row.parentPromoterName || '-' }}</template>
              </el-table-column>
              <el-table-column label="离职交接人员" prop="handoverName" min-width="130" align="center">
                <template slot-scope="{row}">{{ row.handoverName || '-' }}</template>
              </el-table-column>
              <el-table-column label="创建时间" prop="createTime" min-width="170" align="center"></el-table-column>
              <el-table-column label="操作人" prop="operator" min-width="100" align="center"></el-table-column>
              <el-table-column label="操作" min-width="230" align="center" fixed="right">
                <template slot-scope="{row}">
                  <el-button v-if="row.bossFlag !== 1" type="text" size="mini" @click="openSuperiorDialog(row)">配置上级</el-button>
                  <el-button type="text" size="mini" @click="downloadPromoterCode(row)">下载推广码</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>

        <el-tab-pane label="推广费规则" name="rule">
          <div v-loading="ruleLoading" class="tab-body fee-rule-panel">
            <div class="rule-title-row">
              <div>
                <div class="panel-title">创建推广费规则</div>
                <div class="panel-desc">推广人根据层级比例可以获得对应比例的推广费用</div>
              </div>
              <el-button v-if="overview.feeRule && !ruleEditing" type="primary" size="small" @click="editRule">编辑</el-button>
            </div>
            <el-form ref="ruleForm" :model="ruleForm" :rules="ruleRules" label-width="140px" class="fee-rule-form">
              <el-form-item label="生效时间：" prop="effectiveType">
                <span class="form-text">立即生效</span>
              </el-form-item>
              <el-form-item label="适用油站：">
                <span class="form-text">{{ currentGasName }}</span>
              </el-form-item>
              <el-form-item label="推广费分配规则：" required>
                <table class="allocation-rate-table">
                  <thead>
                    <tr>
                      <th>推广人</th>
                      <th>推广人上级</th>
                      <th>推广人上上级</th>
                      <th>老板</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                      <el-input
                        v-model="ruleForm.promoterRate"
                        class="rate-input"
                        size="small"
                        @input="handleRateInput($event, 'promoterRate')"
                        @blur="handleRateBlur('promoterRate')">
                        <template slot="append">%</template>
                      </el-input>
                      </td>
                      <td>
                      <el-input
                        v-model="ruleForm.parentRate"
                        class="rate-input"
                        size="small"
                        @input="handleRateInput($event, 'parentRate')"
                        @blur="handleRateBlur('parentRate')">
                        <template slot="append">%</template>
                      </el-input>
                      </td>
                      <td>
                      <el-input
                        v-model="ruleForm.grandparentRate"
                        class="rate-input"
                        size="small"
                        @input="handleRateInput($event, 'grandparentRate')"
                        @blur="handleRateBlur('grandparentRate')">
                        <template slot="append">%</template>
                      </el-input>
                      </td>
                      <td>
                      <el-input :value="String(bossRate)" class="rate-input" size="small" disabled>
                        <template slot="append">%</template>
                      </el-input>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </el-form-item>
            </el-form>

            <div class="rule-explain">
              <div>说明</div>
              <div>1、最新创建推广人推广客户时按最新生效的推广费规则分配</div>
              <div>2、推广人列表中都可为推广，按照推广人找寻各自的上级进行推广费分配</div>
              <div>3、当推广人上级缺失，缺失比例合并至老板</div>
            </div>

            <div class="section-title detail-title">详细推广人比例</div>
            <el-table :data="rulePreviewList" border size="small" class="rule-preview-table" empty-text="暂无推广人">
              <el-table-column label="推广人" prop="promoterText" min-width="160" align="center"></el-table-column>
              <el-table-column label="推广人上级" prop="parentText" min-width="160" align="center"></el-table-column>
              <el-table-column label="推广人上上级" prop="grandparentText" min-width="160" align="center"></el-table-column>
              <el-table-column label="老板" prop="bossText" min-width="160" align="center"></el-table-column>
            </el-table>

            <div v-if="ruleEditing" class="bottom-action rule-bottom-action">
              <el-button type="primary" :loading="ruleSubmitting" @click="saveRule">保存</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="推广费规则记录" name="record">
          <div class="tab-body">
            <el-form :inline="true" :model="recordSearchForm" size="small" class="record-search">
              <el-form-item label="规则状态：">
                <el-select v-model="recordSearchForm.ruleStatus" clearable placeholder="全部">
                  <el-option label="生效中" value="生效中"></el-option>
                  <el-option label="已过期" value="已过期"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="small" @click="resetRecordSearch">重置</el-button>
                <el-button type="primary" size="small" @click="queryRuleRecordList">搜索</el-button>
              </el-form-item>
            </el-form>

            <div class="section-title record-title">推广费规则记录</div>
            <el-table v-loading="ruleRecordLoading" :data="ruleRecordList" border stripe size="small" empty-text="暂无推广费规则记录" style="width: 100%">
              <el-table-column label="规则ID" prop="ruleId" min-width="170" align="center"></el-table-column>
              <el-table-column label="适用场站" prop="gasName" min-width="150" align="center"></el-table-column>
              <el-table-column label="规则状态" prop="status" min-width="110" align="center">
                <template slot-scope="{row}">
                  <el-tag :type="row.status === '生效中' ? 'success' : 'info'" size="mini">{{ row.status }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="生效时间" prop="effectiveTime" min-width="170" align="center"></el-table-column>
              <el-table-column label="操作人" prop="operator" min-width="100" align="center"></el-table-column>
              <el-table-column label="操作" min-width="110" align="center" fixed="right">
                <template slot-scope="{row}">
                  <el-button type="text" size="mini" @click="openRuleRecordDetail(row)">查看详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-dialog title="添加推广人" :visible.sync="promoterDialogVisible" width="720px" class="promoter-dialog" @closed="resetPromoterForm">
      <el-form ref="promoterForm" :model="promoterForm" :rules="promoterRules" label-width="110px">
        <el-form-item label="人员名称" prop="promoterName">
          <el-input v-model.trim="promoterForm.promoterName" maxlength="10" show-word-limit placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="promoterMobile">
          <el-input v-model.trim="promoterForm.promoterMobile" maxlength="11" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="推广人上级" prop="parentPromoterId">
          <el-select
            v-model="promoterForm.parentPromoterId"
            filterable
            remote
            reserve-keyword
            clearable
            :remote-method="searchSuperiorOptions"
            :loading="superiorLoading"
            placeholder="请输入">
            <el-option
              v-for="item in superiorOptions"
              :key="item.promoterId"
              :label="item.promoterName"
              :value="item.promoterId">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="dialog-tips">
          <div>1、建议从管理层从上往下创建人员</div>
          <div>2、配置的上级将会根据推广费规则获得部分推广费收益</div>
          <div>3、不可相互绑定，比如张三绑李四，李四不可绑张三</div>
          <div>4、最大为四个层级，并且不可绑定自己的下级</div>
          <div>5、添加推广人未配置推广费规则，可照常推广，推广费全部给到老板</div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="promoterDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="promoterSubmitting" @click="createPromoterAccount">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="配置上级" :visible.sync="superiorDialogVisible" width="720px" class="promoter-dialog" @closed="resetSuperiorForm">
      <el-form ref="superiorForm" :model="superiorForm" :rules="superiorRules" label-width="130px">
        <el-form-item label="当前推广人：">
          <span class="form-text">{{ currentPromoter ? currentPromoter.promoterName : '--' }}</span>
        </el-form-item>
        <el-form-item label="推广人上级：" prop="parentPromoterId">
          <el-select
            v-model="superiorForm.parentPromoterId"
            filterable
            remote
            reserve-keyword
            clearable
            :remote-method="searchSuperiorOptions"
            :loading="superiorLoading"
            placeholder="请输入">
            <el-option
              v-for="item in superiorOptions"
              :key="item.promoterId"
              :label="item.promoterName"
              :value="item.promoterId">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="dialog-tips superior-tips">
          <div>说明：</div>
          <div>1、配置的上级将会根据推广费规则获得部分推广费收益</div>
          <div>2、不可相互绑定，比如张三绑李四，李四不可绑张三</div>
          <div>3、最大为四个层级，并且不可绑定自己的下级</div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="superiorDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="superiorSubmitting" @click="confirmSuperior">确定</el-button>
      </span>
    </el-dialog>

      <el-dialog title="规则详情" :visible.sync="ruleRecordDetailVisible" width="520px">
        <el-table :data="ruleRecordDetailRows" border size="small" empty-text="暂无规则详情" style="width: 100%">
          <el-table-column label="推广人" prop="promoterRate" align="center"></el-table-column>
          <el-table-column label="推广人上级" prop="parentRate" align="center"></el-table-column>
          <el-table-column label="推广人上上级" prop="grandparentRate" align="center"></el-table-column>
          <el-table-column label="老板" prop="bossRate" align="center"></el-table-column>
        </el-table>
        <span slot="footer">
          <el-button type="primary" size="small" @click="ruleRecordDetailVisible = false">确定</el-button>
        </span>
          </el-dialog>
        </div>
      </template>
    </real-name-auth-gate>
  </div>
</template>

<script>
import {
  queryBossAccount,
  getPromotionFeeRuleDetail,
  createBossAccount,
  createPromoter,
  queryPromoterManageList,
  queryUplineCandidates,
  queryPromoterFeeChainList,
  updatePromoterSuperior,
  savePromotionFeeRule,
  queryPromotionFeeRuleRecordList,
  getSetupProgress,
  getPersonQrUrl,
  getStationQrUrl,
  getDistributorResourceList
} from '@/api/promotionManage'
import RealNameAuthGate from '../components/realNameAuthGate'

const phoneReg = /^1[3456789]\d{9}$/

export default {
  name: 'promotionManage_promoterRule',
  components: {
    RealNameAuthGate
  },
  data () {
    return {
      gasId: '',
      gasList: [],
      activeTab: 'boss',
      overview: {
        steps: [],
        bossAccount: null,
        promoters: [],
        promoterFeeChains: [],
        feeRule: null,
        ruleRecords: []
      },
      setupProgress: {
        bossCreated: 0,
        promoterCreated: 0,
        feeRuleConfigured: 0
      },
      bossForm: {
        bossName: '',
        bossMobile: ''
      },
      promoterForm: {
        promoterName: '',
        promoterMobile: '',
        parentPromoterId: ''
      },
      promoterSearchForm: {
        promoterName: '',
        createTimeStart: '',
        createTimeEnd: ''
      },
      recordSearchForm: {
        ruleStatus: ''
      },
      promoterCreateTime: [],
      promoterTableData: [],
      ruleRecordList: [],
      superiorOptions: [],
      currentPromoter: null,
      currentRuleRecord: null,
      superiorForm: {
        parentPromoterId: ''
      },
      ruleForm: {
        effectiveType: 'immediate',
        promoterRate: 50,
        parentRate: 10,
        grandparentRate: 20,
        bossRate: 20
      },
      ruleEditing: true,
      rulePreviewList: [],
      promoterDialogVisible: false,
      superiorDialogVisible: false,
      ruleRecordDetailVisible: false,
      bossSubmitting: false,
      promoterSubmitting: false,
      superiorSubmitting: false,
      superiorLoading: false,
      ruleSubmitting: false,
      bossLoading: false,
      promoterListLoading: false,
      ruleLoading: false,
      ruleRecordLoading: false,
      bossRules: {
        bossName: [
          { required: true, message: '请输入人员名称', trigger: 'blur' },
          { max: 10, message: '人员名称最多10个字', trigger: 'blur' }
        ],
        bossMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: phoneReg, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      },
      promoterRules: {
        promoterName: [
          { required: true, message: '请输入人员名称', trigger: 'blur' },
          { max: 10, message: '人员名称最多10个字', trigger: 'blur' }
        ],
        promoterMobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: phoneReg, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        parentPromoterId: [{ required: true, message: '请选择推广人上级', trigger: 'change' }]
      },
      superiorRules: {
        parentPromoterId: [{ required: true, message: '请选择推广人上级', trigger: 'change' }]
      },
      ruleRules: {
        promoterRate: [{ required: true, message: '请输入推广人比例', trigger: 'blur' }],
        parentRate: [{ required: true, message: '请输入推广人上级比例', trigger: 'blur' }],
        grandparentRate: [{ required: true, message: '请输入推广人上上级比例', trigger: 'blur' }]
      }
    }
  },
  computed: {
    hasBossAccount () {
      return !!this.overview.bossAccount
    },
    bossStepCompleted () {
      return Number(this.setupProgress.bossCreated) === 1 || this.hasBossAccount
    },
    promoterStepCompleted () {
      return Number(this.setupProgress.promoterCreated) === 1
    },
    feeRuleStepCompleted () {
      return Number(this.setupProgress.feeRuleConfigured) === 1
    },
    steps () {
      const optionalTip = '可选配置，未配置推广人与推广费规则可照常推广，默认推广费100%至老板账户'
      return [
        {
          key: 'bossAccount',
          title: '创建老板账户',
          completed: this.bossStepCompleted,
          statusText: this.bossStepCompleted ? '已完成' : '未完成'
        },
        {
          key: 'promoter',
          title: '创建推广人',
          completed: this.promoterStepCompleted,
          statusText: this.promoterStepCompleted ? '已配置' : '未配置(可选)',
          tip: optionalTip
        },
        {
          key: 'feeRule',
          title: '创建推广费规则',
          completed: this.feeRuleStepCompleted,
          statusText: this.feeRuleStepCompleted ? '已配置' : '未配置(可选)'
        }
      ]
    },
    currentGasName () {
      const gas = this.gasList.find(item => item.gasId === this.gasId)
      return gas ? gas.gasName : '--'
    },
    activeStepIndex () {
      const stepMap = {
        boss: 0,
        promoter: 1,
        rule: 2,
        record: 2
      }
      return stepMap[this.activeTab] || 0
    },
    bossRate () {
      const bossRate = 100 - Number(this.ruleForm.promoterRate || 0) - Number(this.ruleForm.parentRate || 0) - Number(this.ruleForm.grandparentRate || 0)
      return bossRate < 0 ? 0 : bossRate
    },
    ruleRecordDetailRows () {
      if (!this.currentRuleRecord) return []
      return [
        {
          promoterRate: `${this.currentRuleRecord.promoterRate || 0}%`,
          parentRate: `${this.currentRuleRecord.parentRate || 0}%`,
          grandparentRate: `${this.currentRuleRecord.grandparentRate || 0}%`,
          bossRate: `${this.currentRuleRecord.bossRate || 0}%`
        }
      ]
    }
  },
  watch: {
    activeTab (tabName) {
      this.loadTabData(tabName)
    }
  },
  methods: {
    // 推广管理相关接口存在两套成功码：历史接口多为200，新接口文档为0。
    isSuccess (code) {
      return code === 0 || code === 200
    },
    // 兼容普通数组与分页结构 result.list，减少不同接口返回结构对页面的影响。
    getListResult (result) {
      if (Array.isArray(result)) return result
      return result && Array.isArray(result.list) ? result.list : []
    },
    normalizeBossAccount (item) {
      // 老板账户接口返回 mobile，页面内部统一使用 bossMobile 展示。
      if (!item) return null
      return {
        ...item,
        bossName: item.bossName || item.name || '',
        bossMobile: item.bossMobile || item.mobile || '',
        gasName: item.gasName || this.currentGasName
      }
    },
    normalizePromoter (item) {
      // 推广人管理页同时依赖列表展示、上级选择和比例预览，统一转换成页面字段。
      return {
        ...item,
        promoterId: item.promoterId || item.distributorId || item.id,
        promoterName: item.promoterName || item.name || '',
        promoterMobile: item.promoterMobile || item.mobile || '',
        gasName: item.gasName || item.stationName || this.currentGasName,
        parentPromoterId: item.parentPromoterId || item.parentDistributorId || '',
        parentPromoterName: item.parentPromoterName || item.parentDistributorName || item.parentName || '',
        handoverName: item.handoverName || '',
        operator: item.operator || item.createUser || ''
      }
    },
    normalizeSuperiorCandidate (item) {
      return {
        ...item,
        promoterId: item.promoterId || item.distributorId || item.id,
        promoterName: item.roleDesc ? `${item.name || item.promoterName || ''}（${item.roleDesc}）` : (item.name || item.promoterName || '')
      }
    },
    normalizePromoterFeeChain (item) {
      // listPromoterFeeChain 返回 self/parent/grandparent/boss 四段链路结构。
      // ratio 非空时以后端返回比例展示；ratio 为空时用当前规则配置比例做预览。
      const self = item.self || {}
      const parent = item.parent || {}
      const grandparent = item.grandparent || {}
      const boss = item.boss || {}
      const hasPromoterSelf = !!(item.self && (self.distributorId || self.name))
      const promoter = this.normalizePromoter({
        ...item,
        distributorId: self.distributorId || item.distributorId,
        name: self.name || item.name,
        parentDistributorId: parent.distributorId || item.parentDistributorId,
        parentDistributorName: parent.name || item.parentDistributorName
      })
      return {
        ...promoter,
        hasPromoterSelf,
        grandparentPromoterId: grandparent.distributorId || item.grandparentPromoterId || item.grandparentDistributorId || '',
        grandparentPromoterName: grandparent.name || item.grandparentPromoterName || item.grandparentDistributorName || item.grandparentName || '',
        bossName: boss.name || item.bossName || item.bossDistributorName || '',
        selfRatio: self.ratio,
        parentRatio: parent.ratio,
        grandparentRatio: grandparent.ratio,
        bossRatio: boss.ratio
      }
    },
    normalizeRule (item) {
      // 规则接口字段为 selfRatio/parentRatio/grandparentRatio/bossRatio，
      // 页面内部沿用 promoterRate/parentRate/grandparentRate/bossRate。
      if (!item) return null
      return {
        ...item,
        effectiveType: item.effectiveType || 'immediate',
        promoterRate: item.promoterRate === undefined ? item.selfRatio : item.promoterRate,
        parentRate: item.parentRate === undefined ? item.parentRatio : item.parentRate,
        grandparentRate: item.grandparentRate === undefined ? item.grandparentRatio : item.grandparentRate,
        bossRate: item.bossRate === undefined ? item.bossRatio : item.bossRate
      }
    },
    normalizeRuleRecord (item) {
      // 规则记录没有显式状态时，用 expireTime 判断“生效中/已过期”。
      const normalizedRule = this.normalizeRule(item) || {}
      return {
        ...normalizedRule,
        ruleId: item.ruleId || item.id,
        gasName: item.gasName || item.stationName || this.currentGasName,
        status: item.status || (item.expireTime ? '已过期' : '生效中'),
        effectiveTime: item.effectiveTime || item.createTime || '',
        operator: item.operator || item.createUser || ''
      }
    },
    normalizeGas (item) {
      return {
        ...item,
        gasId: item.gasId || item.stationId || item.id,
        gasName: item.gasName || item.stationName || item.name
      }
    },
    async init () {
      await this.getGasList()
      this.getOverview()
    },
    async getGasList () {
      try {
        const { code, result = [] } = await getDistributorResourceList()
        if (!this.isSuccess(code)) return
        const list = this.getListResult(result)
          .map(this.normalizeGas)
          .filter(item => item.gasId && item.gasName)
        this.gasList = list
        if (!this.gasId && list.length) this.gasId = list[0].gasId
      } catch (error) {
        this.gasList = []
      }
    },
    async getOverview () {
      if (!this.gasId) return
      // 进入页面先拉步骤进度，再只加载当前tab所需数据；其他tab切换时懒加载。
      await this.querySetupProgress()
      await this.loadTabData(this.activeTab)
    },
    async loadTabData (tabName) {
      if (!this.gasId) return
      if (tabName === 'boss') {
        await this.queryBossInfo()
        return
      }
      if (tabName === 'promoter') {
        await this.queryPromoterList()
        return
      }
      if (tabName === 'rule') {
        this.ruleLoading = true
        try {
          await this.queryCurrentRule(false)
          await this.queryPromoterFeeChainList(false)
          this.refreshRulePreview()
        } finally {
          this.ruleLoading = false
        }
        return
      }
      if (tabName === 'record') {
        await this.queryRuleRecordList()
      }
    },
    async querySetupProgress () {
      try {
        const { code, result } = await getSetupProgress({ gasId: this.gasId })
        if (!this.isSuccess(code)) return
        this.setupProgress = {
          bossCreated: result ? result.bossCreated : 0,
          promoterCreated: result ? result.promoterCreated : 0,
          feeRuleConfigured: result ? result.feeRuleConfigured : 0
        }
      } catch (error) {
        this.setupProgress = {
          bossCreated: 0,
          promoterCreated: 0,
          feeRuleConfigured: 0
        }
      }
    },
    async queryBossInfo () {
      this.bossLoading = true
      try {
        const { code, result } = await queryBossAccount({ gasId: this.gasId })
        if (!this.isSuccess(code)) return
        const bossAccount = this.normalizeBossAccount(result)
        this.overview.bossAccount = bossAccount
        this.bossForm = bossAccount
          ? {
            bossName: bossAccount.bossName,
            bossMobile: bossAccount.bossMobile
          }
          : {
            bossName: '',
            bossMobile: ''
          }
      } catch (error) {
        this.$message.error('老板账户获取失败，请稍后重试')
      } finally {
        this.bossLoading = false
      }
    },
    async queryCurrentRule (showLoading = true) {
      if (showLoading) this.ruleLoading = true
      try {
        const { code, result } = await getPromotionFeeRuleDetail({ gasId: this.gasId })
        if (!this.isSuccess(code)) return
        const feeRule = this.normalizeRule(result)
        this.overview.feeRule = feeRule
        this.ruleForm = feeRule
          ? {
            effectiveType: feeRule.effectiveType || 'immediate',
            promoterRate: feeRule.promoterRate === undefined ? 50 : feeRule.promoterRate,
            parentRate: feeRule.parentRate === undefined ? 10 : feeRule.parentRate,
            grandparentRate: feeRule.grandparentRate === undefined ? 20 : feeRule.grandparentRate,
            bossRate: feeRule.bossRate === undefined ? 20 : feeRule.bossRate
          }
          : {
            effectiveType: 'immediate',
            promoterRate: 50,
            parentRate: 10,
            grandparentRate: 20,
            bossRate: 20
          }
        this.ruleEditing = !feeRule
      } catch (error) {
        this.$message.error('推广费规则获取失败，请稍后重试')
      } finally {
        if (showLoading) this.ruleLoading = false
      }
    },
    handleGasChange () {
      this.activeTab = 'boss'
      this.getOverview()
    },
    beforeTabLeave (activeName) {
      // 步骤型页面的业务限制：未完成前置步骤时不允许进入后续tab。
      if (!this.bossStepCompleted && activeName !== 'boss') {
        this.$message.warning('请先完成创建老板账户步骤')
        return false
      }
      if (this.bossStepCompleted && !this.promoterStepCompleted && ['rule', 'record'].includes(activeName)) {
        this.$message.warning('请先完成创建推广人步骤')
        return false
      }
      return true
    },
    handleStepClick (index) {
      // 步骤条与tab共用一套进入限制，避免从步骤条绕过前置校验。
      const tabList = ['boss', 'promoter', 'rule']
      const targetTab = tabList[index] || 'boss'
      if (!this.bossStepCompleted && targetTab !== 'boss') {
        this.$message.warning('请先完成创建老板账户步骤')
        return
      }
      if (this.bossStepCompleted && !this.promoterStepCompleted && targetTab === 'rule') {
        this.$message.warning('请先完成创建推广人步骤')
        return
      }
      this.activeTab = targetTab
    },
    createBoss () {
      if (this.hasBossAccount) return
      this.$refs.bossForm.validate(async valid => {
        if (!valid) return
        try {
          await this.$confirm('请确认是否创建此人为老板账户，推广都会获得推广费的收益', '创建提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch (error) {
          return
        }
        this.bossSubmitting = true
        try {
          const { code } = await createBossAccount({
            gasId: this.gasId,
            name: this.bossForm.bossName,
            mobile: this.bossForm.bossMobile
          })
          if (!this.isSuccess(code)) return
          this.$message.success('老板账户创建成功')
          await this.getOverview()
          this.activeTab = 'promoter'
        } catch (error) {
          this.$message.error('老板账户创建失败，请稍后重试')
        } finally {
          this.bossSubmitting = false
        }
      })
    },
    async queryPromoterList () {
      if (!this.gasId) return
      this.promoterListLoading = true
      try {
        const { code, result = [] } = await queryPromoterManageList({
          gasId: this.gasId,
          promoterName: this.promoterSearchForm.promoterName,
          createStartTime: this.promoterSearchForm.createTimeStart,
          createEndTime: this.promoterSearchForm.createTimeEnd,
          pageIndex: 1,
          pageSize: 999
        })
        if (!this.isSuccess(code)) return
        const list = this.getListResult(result).map(this.normalizePromoter)
        this.promoterTableData = list
        this.overview.promoters = list
        this.refreshRulePreview()
      } catch (error) {
        this.$message.error('推广人列表获取失败，请稍后重试')
      } finally {
        this.promoterListLoading = false
      }
    },
    async queryPromoterFeeChainList (showLoading = true) {
      if (!this.gasId) return
      if (showLoading) this.ruleLoading = true
      try {
        const { code, result = [] } = await queryPromoterFeeChainList({
          gasId: this.gasId
        })
        if (!this.isSuccess(code)) return
        this.overview.promoterFeeChains = this.getListResult(result)
          .filter(item => item)
          .map(this.normalizePromoterFeeChain)
      } catch (error) {
        this.overview.promoterFeeChains = []
        this.$message.error('详细推广人比例获取失败，请稍后重试')
      } finally {
        if (showLoading) this.ruleLoading = false
      }
    },
    handlePromoterTimeChange (value) {
      this.promoterSearchForm.createTimeStart = value ? value[0] : ''
      this.promoterSearchForm.createTimeEnd = value ? value[1] : ''
    },
    resetPromoterSearch () {
      this.promoterSearchForm = {
        promoterName: '',
        createTimeStart: '',
        createTimeEnd: ''
      }
      this.promoterCreateTime = []
      this.queryPromoterList()
    },
    async queryRuleRecordList () {
      if (!this.gasId) return
      this.ruleRecordLoading = true
      try {
        const { code, result = [] } = await queryPromotionFeeRuleRecordList({
          gasId: this.gasId
        })
        if (!this.isSuccess(code)) return
        let list = this.getListResult(result).map(this.normalizeRuleRecord)
        if (this.recordSearchForm.ruleStatus) {
          list = list.filter(item => item.status === this.recordSearchForm.ruleStatus)
        }
        this.ruleRecordList = list
      } catch (error) {
        this.$message.error('推广费规则记录获取失败，请稍后重试')
      } finally {
        this.ruleRecordLoading = false
      }
    },
    resetRecordSearch () {
      this.recordSearchForm = {
        ruleStatus: ''
      }
      this.queryRuleRecordList()
    },
    async searchSuperiorOptions (keyword = '') {
      this.superiorLoading = true
      try {
        if (this.currentPromoter) {
          // 配置上级弹窗使用专用候选接口，后端已剔除当前人员及其下级链路。
          const { code, result = [] } = await queryUplineCandidates({
            gasId: this.gasId,
            distributorId: this.currentPromoter.promoterId,
            keyword
          })
          if (!this.isSuccess(code)) return
          this.superiorOptions = this.getListResult(result).map(this.normalizeSuperiorCandidate)
          return
        }
        // 添加推广人时还没有当前推广人ID，继续使用推广人列表作为上级候选来源。
        const { code, result = [] } = await queryPromoterManageList({
          gasId: this.gasId,
          promoterName: keyword,
          pageIndex: 1,
          pageSize: 999
        })
        if (!this.isSuccess(code)) return
        this.superiorOptions = this.getListResult(result).map(this.normalizePromoter)
      } catch (error) {
        this.$message.error('推广人上级查询失败，请稍后重试')
      } finally {
        this.superiorLoading = false
      }
    },
    openAddPromoterDialog () {
      this.currentPromoter = null
      this.promoterDialogVisible = true
      this.searchSuperiorOptions('')
    },
    createPromoterAccount () {
      this.$refs.promoterForm.validate(async valid => {
        if (!valid) return
        this.promoterSubmitting = true
        try {
          const { code, message } = await createPromoter({
            gasId: this.gasId,
            name: this.promoterForm.promoterName,
            mobile: this.promoterForm.promoterMobile,
            parentDistributorId: this.promoterForm.parentPromoterId === 'BOSS' ? null : this.promoterForm.parentPromoterId
          })
          if (!this.isSuccess(code)) {
            this.$message.warning(message || '推广人创建失败')
            return
          }
          this.$message.success('推广人创建成功')
          this.promoterDialogVisible = false
          await this.getOverview()
        } catch (error) {
          this.$message.error('推广人创建失败，请稍后重试')
        } finally {
          this.promoterSubmitting = false
        }
      })
    },
    getParentPromoter (promoter, list = this.overview.promoters) {
      if (!promoter || !promoter.parentPromoterId || promoter.parentPromoterId === 'BOSS') return null
      return (list || []).find(item => item.promoterId === promoter.parentPromoterId) || null
    },
    formatRoleText (person, rate) {
      // 比例 0 也是有效配置，只有该层级无人（person 为空）时才展示占位符
      if (!person || !person.promoterName) return '-'
      return `${person.promoterName}/${rate}%`
    },
    formatBossText (rate, bossName) {
      bossName = bossName || (this.overview.bossAccount ? this.overview.bossAccount.bossName : '老板')
      return `${bossName}/${rate}%`
    },
    isEmptyRate (rate) {
      return rate === null || rate === undefined || rate === ''
    },
    getDisplayRate (backendRate, fallbackRate) {
      return this.isEmptyRate(backendRate) ? fallbackRate : Number(backendRate)
    },
    handleRateInput (value, field) {
      this.ruleEditing = true
      const cleanValue = String(value).replace(/[^\d]/g, '')
      if (cleanValue === '') {
        this.ruleForm[field] = ''
      } else {
        this.ruleForm[field] = String(Math.min(Number(cleanValue), 100))
      }
      this.refreshRulePreview()
    },
    handleRateBlur (field) {
      this.ruleEditing = true
      const value = parseInt(this.ruleForm[field], 10)
      if (Number.isNaN(value) || value < 0) {
        this.ruleForm[field] = 0
      } else if (value > 100) {
        this.ruleForm[field] = 100
      } else {
        this.ruleForm[field] = value
      }
      this.refreshRulePreview()
    },
    refreshRulePreview () {
      // 详细推广人比例：self.ratio 为空表示未配置规则，整条链按页面当前规则比例预览；否则使用后端返回比例。
      const promoterRate = Number(this.ruleForm.promoterRate || 0)
      const parentRate = Number(this.ruleForm.parentRate || 0)
      const grandparentRate = Number(this.ruleForm.grandparentRate || 0)
      const baseBossRate = 100 - promoterRate - parentRate - grandparentRate
      const safeBossRate = baseBossRate < 0 ? 0 : baseBossRate
      this.ruleForm.bossRate = safeBossRate
      const feeChainList = this.overview.promoterFeeChains || []
      this.rulePreviewList = feeChainList
        .filter(item => item.status !== 0)
        .map(promoter => {
          if (!promoter.hasPromoterSelf && promoter.bossName) {
            return {
              promoterText: '-',
              parentText: '-',
              grandparentText: '-',
              bossText: this.formatBossText(this.getDisplayRate(promoter.bossRatio, 100), promoter.bossName)
            }
          }
          const parent = promoter.parentPromoterName
            ? { promoterName: promoter.parentPromoterName }
            : this.getParentPromoter(promoter, feeChainList)
          const grandparent = promoter.grandparentPromoterName
            ? { promoterName: promoter.grandparentPromoterName }
            : this.getParentPromoter(parent, feeChainList)
          const fallbackBossRate = safeBossRate + (parent ? 0 : parentRate) + (grandparent ? 0 : grandparentRate)
          const shouldUseBackendRate = !this.ruleEditing && !this.isEmptyRate(promoter.selfRatio)
          const displayPromoterRate = shouldUseBackendRate ? Number(promoter.selfRatio) : promoterRate
          const displayParentRate = shouldUseBackendRate ? this.getDisplayRate(promoter.parentRatio, parentRate) : parentRate
          const displayGrandparentRate = shouldUseBackendRate ? this.getDisplayRate(promoter.grandparentRatio, grandparentRate) : grandparentRate
          const bossRate = shouldUseBackendRate ? this.getDisplayRate(promoter.bossRatio, fallbackBossRate) : fallbackBossRate
          return {
            promoterText: `${promoter.promoterName}/${displayPromoterRate}%`,
            parentText: this.formatRoleText(parent, displayParentRate),
            grandparentText: this.formatRoleText(grandparent, displayGrandparentRate),
            bossText: this.formatBossText(bossRate, promoter.bossName)
          }
        })
    },
    editRule () {
      this.ruleEditing = true
      this.refreshRulePreview()
    },
    saveRule () {
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) return
        // 老板比例由 100 - 其他三档比例自动计算，因此只校验可编辑的三档比例。
        const rateFields = [
          { field: 'promoterRate', label: '推广人比例' },
          { field: 'parentRate', label: '推广人上级比例' },
          { field: 'grandparentRate', label: '推广人上上级比例' }
        ]
        const emptyRate = rateFields.find(item => this.ruleForm[item.field] === '' || this.ruleForm[item.field] === null || this.ruleForm[item.field] === undefined)
        if (emptyRate) {
          this.$message.warning(`请输入${emptyRate.label}`)
          return
        }
        rateFields.forEach(item => this.handleRateBlur(item.field))
        this.refreshRulePreview()
        const totalRate = Number(this.ruleForm.promoterRate || 0) + Number(this.ruleForm.parentRate || 0) + Number(this.ruleForm.grandparentRate || 0)
        if (totalRate > 100) {
          this.$message.warning('推广人、推广人上级、推广人上上级比例之和不可超过100%')
          return
        }
        try {
          await this.$confirm('请确认是否保存此规则，立即将按新规则进行推广费分配', '保存提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch (error) {
          return
        }
        this.ruleSubmitting = true
        try {
          const { code } = await savePromotionFeeRule({
            gasId: this.gasId,
            selfRatio: this.ruleForm.promoterRate,
            parentRatio: this.ruleForm.parentRate,
            grandparentRatio: this.ruleForm.grandparentRate,
            bossRatio: this.bossRate
          })
          if (!this.isSuccess(code)) return
          this.$message.success('推广费规则保存成功')
          await this.getOverview()
          this.ruleEditing = false
        } catch (error) {
          this.$message.error('推广费规则保存失败，请稍后重试')
        } finally {
          this.ruleSubmitting = false
        }
      })
    },
    openSuperiorDialog (row) {
      this.currentPromoter = row
      this.superiorForm.parentPromoterId = row.parentPromoterId || ''
      this.superiorDialogVisible = true
      this.searchSuperiorOptions('')
    },
    openRuleRecordDetail (row) {
      this.currentRuleRecord = row
      this.ruleRecordDetailVisible = true
    },
    confirmSuperior () {
      this.$refs.superiorForm.validate(async valid => {
        if (!valid) return
        this.superiorSubmitting = true
        try {
          const { code, message } = await updatePromoterSuperior({
            gasId: this.gasId,
            distributor: this.currentPromoter.promoterId,
            parentDistributorId: this.superiorForm.parentPromoterId === 'BOSS' ? null : this.superiorForm.parentPromoterId
          })
          if (!this.isSuccess(code)) {
            this.$message.warning(message || '配置失败')
            return
          }
          this.$message.success('上级配置成功')
          this.superiorDialogVisible = false
          await this.getOverview()
        } catch (error) {
          this.$message.error('上级配置失败，请稍后重试')
        } finally {
          this.superiorSubmitting = false
        }
      })
    },
    personHandover () {
      this.$message.info('人员交接功能待后端接口提供后联调')
    },
    getDownloadFileName (url, fileName) {
      if (/\.[a-zA-Z0-9]+$/.test(fileName)) return fileName
      const pureUrl = String(url || '').split('?')[0]
      const extMatch = pureUrl.match(/\.([a-zA-Z0-9]+)$/)
      return extMatch ? `${fileName}.${extMatch[1]}` : `${fileName}.png`
    },
    async downloadImage (url, fileName) {
      if (!url) return
      try {
        const response = await fetch(url)
        if (!response.ok) throw new Error('download failed')
        const blob = await response.blob()
        const objectUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = this.getDownloadFileName(url, fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(objectUrl)
      } catch (error) {
        this.$message.error('推广码下载失败，请稍后重试')
      }
    },
    async downloadQrByUser (row) {
      // 新接口根据油站和推广者ID返回图片URL。
      const distributorId = row.distributorId || row.promoterId || row.id
      if (!distributorId) {
        this.$message.warning('接口暂未返回推广者ID，无法下载推广码')
        return
      }
      const { code, result } = await getPersonQrUrl({
        gasId: this.gasId,
        distributorId
      })
      if (!this.isSuccess(code) || !result) {
        this.$message.warning('暂无推广码')
        return
      }
      await this.downloadImage(result, `${row.promoterName}-推广码`)
    },
    async downloadStationPromotionCode () {
      const { code, result } = await getStationQrUrl({ gasId: this.gasId })
      if (!this.isSuccess(code) || !result) {
        this.$message.warning('暂无油站推广码')
        return
      }
      await this.downloadImage(result, `${this.currentGasName}-推广码`)
    },
    downloadPromoterCode (row) {
      this.downloadQrByUser(row)
    },
    maskPhone (phone) {
      if (!phone) return '-'
      return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
    },
    resetPromoterForm () {
      this.promoterForm = {
        promoterName: '',
        promoterMobile: '',
        parentPromoterId: ''
      }
      this.$nextTick(() => {
        if (this.$refs.promoterForm) this.$refs.promoterForm.clearValidate()
      })
    },
    resetSuperiorForm () {
      this.superiorForm = {
        parentPromoterId: ''
      }
      this.currentPromoter = null
      this.$nextTick(() => {
        if (this.$refs.superiorForm) this.$refs.superiorForm.clearValidate()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.promoter-rule-page {
  // min-height: calc(100vh - 84px);
  padding: 35px 10px;
  padding-bottom: 0;
  background: #F8F9FD;
}

.rule-card {
  min-height: calc(100vh - 162px);
  border: 0;
  border-radius: 10px;

  /deep/ .el-card__body {
    padding: 30px 38px 24px;
  }
}

.station-row {
  display: flex;
  align-items: center;
  margin-bottom: 38px;

  .station-label {
    margin-right: 5px;
    font-size: 18px;
    font-weight: 600;
    color: #1E1F22;
  }

  .station-select {
    width: 360px;
  }
}

.setup-steps {
  display: flex;
  width: 820px;
  margin: 0 auto 24px;
}

.setup-step {
  position: relative;
  flex: 1;
  text-align: center;
  cursor: pointer;

  .step-main {
    position: relative;
    height: 44px;
  }

  .step-circle {
    position: relative;
    z-index: 1;
    width: 44px;
    height: 44px;
    margin: 0 auto;
    border-radius: 50%;
    background: #F1F2F4;
    color: #1E1F22;
    line-height: 44px;
    font-size: 14px;
    font-weight: 600;
  }

  .step-line {
    position: absolute;
    top: 21px;
    left: calc(50% + 22px);
    width: calc(100% - 44px);
    height: 2px;
    background: #1E1F22;
  }

  .step-title {
    margin-top: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #1E1F22;
  }

  .step-tip-icon {
    margin-left: 4px;
    color: #8C97AB;
    font-size: 14px;
    cursor: help;
  }

  .step-status {
    margin-top: 10px;
    color: #FF1F1F;
    font-size: 14px;
    font-weight: 600;
  }

  &.completed {
    .step-circle {
      background: #2F80FF;
      color: #fff;
    }

    .step-status {
      color: #2F80FF;
    }
  }

  &.active .step-circle,
  &:first-child .step-circle {
    background: #2F80FF;
    color: #fff;
  }
}

.rule-tabs {
  margin-top: 16px;

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }

  /deep/ .el-tabs__nav-wrap::after {
    height: 0;
  }

  /deep/ .el-tabs__item {
    height: 44px;
    line-height: 44px;
    font-size: 15px;
  }
}

.boss-panel {
  width: 560px;
  margin: 22px auto 0;
  text-align: center;
}

.panel-title {
  font-size: 18px;
  font-weight: 600;
  color: #1E1F22;
}

.panel-desc {
  margin-top: 8px;
  font-size: 12px;
  color: #1E1F22;
}

.boss-form {
  margin-top: 52px;
  text-align: left;

  /deep/ .el-input__inner {
    background: #F5F7FA;
    border-color: #F5F7FA;
  }
}

.boss-preview {
  width: 420px;
  margin: 52px auto 0;
  padding: 24px 32px;
  background: #F8FAFF;
  border: 1px solid #E5ECFF;
  border-radius: 8px;
  text-align: left;

  .preview-row {
    display: flex;
    align-items: center;
    min-height: 34px;
    font-size: 14px;

    & + .preview-row {
      margin-top: 14px;
    }
  }

  .preview-label {
    width: 90px;
    color: #7A8499;
    text-align: right;
  }

  .preview-value {
    flex: 1;
    color: #1E1F22;
    font-weight: 500;
    margin-left: 5px;
  }
}

.form-text {
  font-size: 14px;
  color: #1E1F22;
}

.form-tip {
  margin: -6px 0 0 90px;
  font-size: 12px;
  color: #1E1F22;
}

.created-tip {
  margin-top: 18px;
  color: #2F80FF;
  font-size: 13px;
}

.bottom-action {
  display: flex;
  justify-content: flex-end;
  margin-top: 130px;
  padding-top: 16px;
  border-top: 1px solid #EDF0F5;

  .el-button {
    width: 96px;
  }
}

.tab-body {
  padding: 28px 0 0;
}

.promoter-search {
  position: relative;
  padding-right: 180px;
  margin-bottom: 54px;

  /deep/ .el-form-item {
    margin-right: 14px;
    margin-bottom: 14px;
  }

  /deep/ .el-input__inner {
    background: #F5F7FA;
    border-color: #F5F7FA;
  }

  /deep/ .el-date-editor {
    width: 410px;
  }

  .search-actions {
    position: absolute;
    right: 0;
    bottom: 0;
    margin-right: 0;
  }
}

.promoter-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.toolbar-actions {
  display: flex;
  gap: 16px;

  .el-button {
    min-width: 148px;
  }
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #1E1F22;
}

.section-desc {
  margin-top: 6px;
  margin-bottom: 18px;
  font-size: 13px;
  color: #606B85;
}

.rule-form-wrap {
  width: 520px;
}

.rule-form {
  margin-top: 22px;

  .unit {
    margin-left: 8px;
  }
}

.fee-rule-panel {
  width: 760px;
  margin: 0 auto;
}

.rule-title-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  margin-bottom: 32px;
  text-align: center;

  .el-button {
    position: absolute;
    right: 0;
    top: 0;
  }
}

.fee-rule-form {
  /deep/ .el-form-item {
    margin-bottom: 24px;
  }

  /deep/ .el-form-item__label {
    color: #7A8499;
    white-space: nowrap;
  }
}

.allocation-rate-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #EBEEF5;

  th {
    height: 40px;
    background: #F5F7FA;
    border: 1px solid #EBEEF5;
    color: #1E1F22;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }

  td {
    height: 54px;
    border: 1px solid #EBEEF5;
    text-align: center;
  }

  .rate-input {
    width: 120px;
  }
}

.rule-explain {
  margin-top: 22px;
  font-size: 14px;
  line-height: 1.8;
  color: #1E1F22;
}

.detail-title {
  margin-top: 24px;
  margin-bottom: 16px;
}

.record-search {
  margin-bottom: 24px;
}

.record-title {
  margin-bottom: 16px;
}

.rule-preview-table {
  /deep/ .el-table__header th {
    background: #F5F7FA;
    color: #1E1F22;
    font-weight: 500;
  }
}

.rule-bottom-action {
  margin-top: 120px;
}

.promoter-dialog {
  /deep/ .el-dialog__header {
    padding: 28px 42px;
    border-bottom: 1px solid #EBEEF5;
  }

  /deep/ .el-dialog__title {
    position: relative;
    padding-left: 12px;
    font-size: 22px;
    font-weight: 600;
    color: #1E1F22;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      width: 4px;
      height: 22px;
      border-radius: 2px;
      background: #2F80FF;
    }
  }

  /deep/ .el-dialog__body {
    padding: 56px 42px 40px;
  }

  /deep/ .el-dialog__footer {
    padding: 24px 42px 28px;
    border-top: 1px solid #EBEEF5;
  }

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }

  /deep/ .el-input__inner {
    height: 46px;
    line-height: 46px;
    background: #F5F7FA;
    border-color: #F5F7FA;
  }

  /deep/ .el-form-item {
    margin-bottom: 34px;
  }

  /deep/ .el-form-item__label {
    font-size: 16px;
    color: #7A8499;
  }

  /deep/ .el-dialog__footer .el-button {
    min-width: 120px;
    height: 42px;
    font-size: 16px;
  }
}

.dialog-tips {
  margin-left: 110px;
  margin-top: -8px;
  font-size: 16px;
  line-height: 1.75;
  color: #1E1F22;
}

.superior-tips {
  margin-left: 0;
  margin-top: 42px;
}
</style>
